module.exports = __webpack_public_path__ + "img/mgh-kanazawa-sp.2252c9c7.jpg";